export default "__VITE_ASSET__DyHkLM67__"